import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

import { Controls } from './controls/controls';
import { downloadFile, JSONLD_MIME_TYPE, textToMinifiedJson } from '../../utils/utils';

import { FileProperties } from '../../models/file.models';
import { Editor } from '../editor/editor';
import { FileDropBox, FileDropBoxHandle } from '../file-drop-box/file-drop-box';
import { Box, Stack } from '@mui/material';
import { cssGlobals } from '../../app';
import { FileDescription } from './file-description/file-description';

interface JsonPanelProps {
  content: string;
  fileProperties?: FileProperties;
  onFileLoad: (content: string, properties: FileProperties, f?: any) => void;
  onFileEdit: () => void;
  onConversionClick: (file: string) => void;
}

export const JsonPanel: FC<JsonPanelProps> = ({
  content, fileProperties, onFileLoad, onFileEdit, onConversionClick
}) => {
  const [file, setFile] = useState<string>('');
  const fileDropBox = useRef<FileDropBoxHandle>(null);
  const onDrop = useCallback((files: File[]) => {
    const reader = new FileReader();
    const acceptedFile = files[0];
    reader.readAsText(acceptedFile)

    reader.onabort = () => console.error('file reading was aborted')
    reader.onerror = () => console.error('file reading has failed')
    reader.onload = () => onFileLoad(reader.result as string, { size: acceptedFile.size, name: acceptedFile.name }, acceptedFile)
  }, [])

  useEffect(() => setFile(content), [content]);
  useEffect(() => {
   if (content !== file) {
     onFileEdit();
   }
  }, [file]);


  // const style = useMemo(() => ({
  //   ...baseStyle,
  //   ...(isFocused ? focusedStyle : {}),
  //   ...(isDragAccept ? acceptStyle : {}),
  //   ...(isDragReject ? rejectStyle : {})
  // }), [
  //   isFocused,
  //   isDragAccept,
  //   isDragReject
  // ]);

  // useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    // files.forEach((file) => URL.revokeObjectURL(file.preview));
  // }, [file]);

  const add = () => {
    if (fileDropBox.current) {
      fileDropBox.current.importFile();
    }
  }
  const download = () => {
    if (file) {
      const fileContents = textToMinifiedJson(file);
      downloadFile(fileContents, fileProperties?.name, JSONLD_MIME_TYPE);
    }
  }
  const convert = () => onConversionClick(file);

  return(
    <Stack>
      <h2>JSON-LD PANEL</h2>
      {file &&
        <>
          <Box sx={{height: cssGlobals.boxHeight}}>
            <Editor
              mode="json"
              name="json-editor"
              content={file}
              onChange={setFile}
            />
          </Box>

          <Controls onAdd={add} onConvert={convert} onDownload={download} />
          {fileProperties && <FileDescription
            size={fileProperties.size}
            name={fileProperties.name}
          />}
        </>
      }
      <Box sx={{
        height: cssGlobals.boxHeight,
        display: file ? 'none' : 'block'
      }}>
        <FileDropBox
          ref={fileDropBox}
          text={'Drag \'n\' drop JSON-LD file here, or click to select file'}
          accept={{[JSONLD_MIME_TYPE]: ['.jsonld']}}
          onDrop={onDrop}
        />
      </Box>
    </Stack>
  )
};
